import Qty from 'js-quantities';
import { set, get, convert } from '../helpers/UnitHelpers';

class Results {
    _fpeak;
    _frms;
    _pmax;
    _pmin;
    _pcoils;
    _pmagn;
    _thouse;
    _tcoil;
    _pres;
    _upeak;
    _ubus;
    _ipeak;
    _irms;
    _nmax;
    _vrms;

    decimals = 2;

    get fpeak() {
        return this._fpeak !== undefined ? this._fpeak.value : '';
    }

    get frms() {
        return this._frms !== undefined ? this._frms.value : '';
    }

    get pmax() {
        return this._pmax !== undefined ? this._pmax.value : '';
    }

    get pmin() {
        return this._pmin !== undefined ? this._pmin.value : '';
    }

    get pcoils() {
        return this._pcoils !== undefined ? this._pcoils.value : '';
    }

    get pmagn() {
        return this._pmagn !== undefined ? this._pmagn.value : '';
    }

    get thouse() {
        return this._thouse !== undefined ? this._thouse.value : '';
    }

    get tcoil() {
        return this._tcoil !== undefined ? this._tcoil.value : '';
    }

    get pres() {
        return this._pres !== undefined ? this._pres.value : '';
    }

    get upeak() {
        return this._upeak !== undefined ? this._upeak.value : '';
    }

    get ubus() {
        return this._ubus !== undefined ? this._ubus.value : '';
    }

    get ipeak() {
        return this._ipeak !== undefined ? this._ipeak.value : '';
    }

    get irms() {
        return this._irms !== undefined ? this._irms.value : '';
    }

    get nmax() {
        return this._nmax !== undefined ? this._nmax.value : '';
    }

    get vrms() {
        return this._vrms !== undefined ? this._vrms : '';
    }

    /**
     * Create a deep copy of the object.
     * @returns {*}
     */
    copy() {
        return Object.assign(Object.create(this), this);
    }

    /**
     * Create a json representation of the movement profile.
     * @returns {{moving_distance, moving_time, acc_time, max_volts, load, order}}
     */
    // toJson() {
    //     let cpy = this.copy();
    //     cpy.convert('si');
    //
    //     return {
    //         temp_heatsink: Qty.parse(cpy.tempHeatsink).scalar,
    //         rtherm_heatsink: Qty.parse(cpy.rthermHeatsink).scalar,
    //         moving_mass: Qty.parse(cpy.movingMass).scalar,
    //         inclinement_angle: Qty.parse(cpy.inclinementAngle).scalar,
    //         friction_force: Qty.parse(cpy.frictionForce).scalar,
    //         power_supply: Qty.parse(cpy.powerSupply).scalar
    //     };
    // }

    /**
     * Create an instance form a json object.
     * @param json
     * @returns {MovementProfile}
     */
    static fromJson(json) {
        let results = new Results();

        if (json !== undefined) {
            results._fpeak = json.fpeak;
            results._frms = json.frms;
            results._pmax = json.pmax;
            results._pmin = json.pmin;
            results._tcoil = json.tcoil;
            results._pcoils = json.pcoils;
            results._pmagn = json.pmagn;
            results._thouse = json.thouse;
            results._pres = json.pres;
            results._upeak = json.upeak;
            results._ubus = json.ubus;
            results._ipeak = json.ipeak;
            results._irms = json.irms;
            results._nmax = json.nmax;
            results._vrms = json.vrms;
        }

        return results;
    }
}

export default Results;
